// library
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Paper, styled, Typography, ButtonBase, Grid, Box, Button } from '@mui/material';
import _ from "lodash";
import { Helmet } from "react-helmet";
// data
import getSightseeing from "../common/sightseeing";
// component
import SightseeingInfoDialog from "./sightseeing-info-dialog";
// type
import { Sightseeing } from "../types/sightseeing";

const SightseeingInfo: FC<any> = (props: { 
        config: any, 
        setIsSettingDisplay: any,
        setSelectSightseeing: any,
        selectPrefecture: number | null,
        setSelectPrefecture: any,
    }) =>{
    const { config, setIsSettingDisplay, setSelectSightseeing, selectPrefecture, setSelectPrefecture } = props;

    const [ isOpenDialog, setIsOpenDialog ] = useState<boolean>(false);
    const [ detailSightseeing, setDetailSightseeing ] = useState<Sightseeing>();

    // 都道府県マスター
    const masterPrefecture = config.code_master.pref;

    const Img = styled('img')({
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    });
    
    const SUB_TITLE_MAX_LENGTH = 40;

    /**
     * 観光を地図で表示
     * @param setSightseeing 
     */
    const mapLinkClick = (sightseeing: Sightseeing) => {
        setSelectSightseeing(sightseeing);
        setIsSettingDisplay(true)
    }

    /**
     * 詳細ダイアログを表示
     * @param sightseeing 
     */
    const showDetailDialog = (sightseeing: Sightseeing) => {
        setDetailSightseeing(sightseeing);
        setIsOpenDialog(true);
    }

    if (selectPrefecture === null) {
        // 再度イベント一覧取得
        const localstoragePrefecture = localStorage.getItem('prefecture');
        setSelectPrefecture(Number(localstoragePrefecture));
        setIsSettingDisplay(false);
    }

    const sightseeing: Sightseeing[] = getSightseeing(Number(selectPrefecture));

    // 都道府県選択からマスター情報取得
    const filterPosition = _.filter(masterPrefecture, (pre: any) => {
        return pre.cd === selectPrefecture;
    });
    const prefectureName = _.head(filterPosition)?.name;

    return (
        <>
            <Helmet>
                <title>{`${prefectureName}観光情報 | ${prefectureName}観光情報を地図で確認`}</title>
                <meta name="description" content={`${prefectureName}の観光情報を地図で確認。イベント情報も同時に確認できます。`} />
                <meta property="og:title" content={`観光とイベント`} />
                <meta property="og:description" content={`${prefectureName}のイベント情報を地図で確認できます！`} />
                <meta property="og:url" content="https://eventamap.com/sightseeing" />
            </Helmet>
            <Box 
                sx={{
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    padding: 2
                }}
            >
            {_.map(sightseeing, (ss: Sightseeing, index: number) => (
                <Paper
                    key={index}
                    sx={{
                        p: 2,
                        width: 400,
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item
                            sx={{ margin: 'auto' }}
                        >
                            <ButtonBase sx={{ width: 200, height: 120 }}>
                                <Img 
                                    alt={ss.title}
                                    src={`${config.localImageUrl}${ss.image}.jpg`}
                                    onClick={() => showDetailDialog(ss)} 
                                />
                <Typography
                    sx={{
                        position: "absolute",
                        bottom: 10,
                        left: 20,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        padding: "4px 8px",
                        fontSize: "13px",
                        borderRadius: "4px",
                    }}
                >
                    詳細を見る
                </Typography>


                            </ButtonBase>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2}>
                                <Grid item xs>
                                    <Typography gutterBottom variant="subtitle1" component="div">
                                        {ss.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'left' }}>
                                        {ss.description.substring(0, SUB_TITLE_MAX_LENGTH) + '...'}
                                    </Typography>
                                    </Grid>
                                    <Grid item>
                                    <Typography sx={{ cursor: 'pointer' }} variant="body2">
                                        <Button
                                            component={Link}
                                            to="/"
                                            onClick={() => mapLinkClick(ss)}
                                            variant="contained" // ボタンのスタイルを指定（"contained" で背景色付き）
                                            sx={{ textTransform: 'none' }} // ボタンのテキストをそのまま表示
                                            color="success"
                                        >
                                            地図で表示
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                ))}
                <SightseeingInfoDialog 
                    config={config}
                    isOpenDialog={isOpenDialog}
                    setIsOpenDialog={setIsOpenDialog}
                    detailSightseeing={detailSightseeing}
                />
            </Box>
        </>
    );
}

export default SightseeingInfo;